/* eslint-disable max-len */
import LocalizedStrings from 'react-localization';
import enUs from './en_us.properties';
import itIt from './it_it.properties';
import caEs from './ca_es.properties';
import daDk from './da_dk.properties';
import deAt from './de_at.properties';
import deCh from './de_ch.properties';
import deDe from './de_de.properties';
import enAu from './en_au.properties';
import enCa from './en_ca.properties';
import enGb from './en_gb.properties';
import enHk from './en_hk.properties';
import enIe from './en_ie.properties';
import enMy from './en_my.properties';
import enNz from './en_nz.properties';
import enPh from './en_ph.properties';
import enSg from './en_sg.properties';
import enEs from './en_es.properties';
import fiFi from './fi_fi.properties';
import frBe from './fr_be.properties';
import frCh from './fr_ch.properties';
import frFr from './fr_fr.properties';
import esAr from './es_ar.properties';
import idId from './id_id.properties';
import esMx from './es_mx.properties';
import esEs from './es_es.properties';
import frCa from './fr_ca.properties';
import inId from './in_id.properties';
import jaJp from './ja_jp.properties';
import koKr from './ko_kr.properties';
import msMy from './ms_my.properties';
import nlBe from './nl_be.properties';
import nlNl from './nl_nl.properties';
import nbNo from './nb_no.properties';
import noNo from './no_no.properties';
import ptBr from './pt_br.properties';
import ptPt from './pt_pt.properties';
import svSe from './sv_se.properties';
import thTh from './th_th.properties';
import viVn from './vi_vn.properties';
import zhCn from './zh_cn.properties';
import zhHk from './zh_hk.properties';
import zhTw from './zh_tw.properties';
import arAe from './ar_ae.properties';
import csCz from './cs_cz.properties';
import deBe from './de_be.properties';
import elGr from './el_gr.properties';
import enAs from './en_as.properties';
import enCn from './en_cn.properties';
import enId from './en_id.properties';
import enIl from './en_il.properties';
import enIn from './en_in.properties';
import enJp from './en_jp.properties';
import enKr from './en_kr.properties';
import enLa from './en_la.properties';
import enMx from './en_mx.properties';
import enTh from './en_th.properties';
import enTw from './en_tw.properties';
import enVn from './en_vn.properties';
import enZa from './en_za.properties';
import esBo from './es_bo.properties';
import esBz from './es_bz.properties';
import esCl from './es_cl.properties';
import esCo from './es_co.properties';
import esCr from './es_cr.properties';
import esEc from './es_ec.properties';
import esGt from './es_gt.properties';
import esGy from './es_gy.properties';
import esHn from './es_hn.properties';
import esNi from './es_ni.properties';
import esPa from './es_pa.properties';
import esPe from './es_pe.properties';
import esPy from './es_py.properties';
import esSv from './es_sv.properties';
import esUy from './es_uy.properties';
import esVe from './es_ve.properties';
import etEe from './et_ee.properties';
import frGf from './fr_gf.properties';
import hrHr from './hr_hr.properties';
import huHu from './hu_hu.properties';
import isIs from './is_is.properties';
import itCh from './it_ch.properties';
import ltLt from './lt_lt.properties';
import lvLv from './lv_lv.properties';
import iwIl from './iw_il.properties';
import nlSr from './nl_sr.properties';
import plPl from './pl_pl.properties';
import ruRu from './ru_ru.properties';
import skSk from './sk_sk.properties';
import trTr from './tr_tr.properties';
import ukUa from './uk_ua.properties';

const Localized = new LocalizedStrings({
  enUs,
  itIt,
  caEs,
  daDk,
  deAt,
  deCh,
  deDe,
  enAu,
  enCa,
  enGb,
  enHk,
  enIe,
  enMy,
  enNz,
  enPh,
  enSg,
  enEs,
  esAr,
  esCo,
  esCr,
  esEs,
  esMx,
  fiFi,
  frBe,
  frCa,
  frCh,
  frFr,
  idId,
  inId,
  jaJp,
  koKr,
  msMy,
  nlBe,
  nlNl,
  nbNo,
  noNo,
  ptBr,
  ptPt,
  svSe,
  thTh,
  viVn,
  zhCn,
  zhHk,
  zhTw,
  arAe,
  csCz,
  deBe,
  elGr,
  enAs,
  enCn,
  enId,
  enIl,
  enIn,
  enJp,
  enKr,
  enLa,
  enMx,
  enTh,
  enTw,
  enVn,
  enZa,
  esBo,
  esBz,
  esCl,
  esEc,
  esGt,
  esGy,
  esHn,
  esNi,
  esPa,
  esPe,
  esPy,
  esSv,
  esUy,
  esVe,
  etEe,
  frGf,
  hrHr,
  huHu,
  isIs,
  itCh,
  ltLt,
  lvLv,
  iwIl,
  nlSr,
  plPl,
  ruRu,
  skSk,
  trTr,
  ukUa,
});
export default Localized;
